import { mapSeriesWithDatetime } from './shared';

export default {
  buildFields() {
    return [
      { key: 'datetime', label: 'Date Time', class: 'text-center' },
      { key: 'onAc', label: 'On AC', class: 'text-center' },
      { key: 'batteryFail', label: 'Battery Fail', class: 'text-center' },
      { key: 'batteryVoltage', label: 'Battery Voltage (V)', class: 'text-center' },
    ];
  },
  buildLogs(seriesData) {
    return mapSeriesWithDatetime(seriesData);
  },
  buildSummary() {
    return {};
  },
};
